"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Config = void 0;
exports.Config = {
    SUMO1_ENV,
    get APPLICATION_TYPE_EXTENSION_URL_MAP() {
        return {
            SUMO1_DEV: 'https://s1-dev-extension.omnito.ai',
            CEP_DEV: 'https://dev-extension.omnito.ai',
            MAIN: 'https://extension.omnito.ai',
            LOCAL: 'https://localhost:3001',
        };
    },
    get SUMO_ENV_APPLICATION_ORIGIN_LIST() {
        return {
            local: 'https://localhost:3000',
            main: 'https://app.omnito.ai',
            stage: 'https://stage.sumourl.com',
            default: `https://${this.SUMO1_ENV}.d2lbrrn1ww9gqj.amplifyapp.com`,
        };
    },
    get SUMO_ENV_EXTENSION_ORIGIN() {
        return (this.APPLICATION_TYPE_EXTENSION_URL_MAP[APPLICATION_TYPE] || SUMO_EXTENSION_ORIGIN || this.APPLICATION_TYPE_EXTENSION_URL_MAP.CEP_DEV);
    },
    get SUMO_ENV_ORIGIN() {
        return (SUMO1_APPLICATION_ORIGIN || this.SUMO_ENV_APPLICATION_ORIGIN_LIST[this.SUMO1_ENV] || this.SUMO_ENV_APPLICATION_ORIGIN_LIST.default);
    },
};
